export const FETCH_PROGRAMS = 'FETCH_PROGRAMS';
export const FETCH_COURSE = 'FETCH_COURSE';
export const POST_COURSE = 'POST_COURSE';
export const PATCH_COURSE = 'PATCH_COURSE';
export const PATCH_CURRENT_COURSE = 'PATCH_CURRENT_COURSE';
export const DELETE_CURRENT_COURSE = 'DELETE_CURRENT_COURSE';
export const DELETE_REMAINING_COURSES = 'DELETE_REMAINING_COURSES';
export const DELETE_COURSE = 'DELETE_COURSE';
export const NOTIFY_COURSE = 'NOTIFY_COURSE';
export const CLOSE_COURSE = 'CLOSE_COURSE';
export const FETCH_STATS = 'FETCH_STATS';
export const FETCH_MULTI_STATS = 'FETCH_MULTI_STATS';

export const COURSE_DRAFT_INITIALIZE = 'COURSE_DRAFT_INITIALIZE';
export const COURSE_DRAFT_FILL = 'COURSE_DRAFT_FILL';

export const COURSE_USED_TRAINERS_FILL = 'COURSE_USED_TRAINERS_FILL';



// WEBPACK FOOTER //
// ./src/store/course/types.js